import {LocalizedDictionary} from '../Translator';

export default {
  "DD": "DD",
  "Discontinued": "Discontinuat",
  "Spare part list": "Lista pieselor de schimb",
  "Download Excel": "Descarcă Excel",
  "Recent search list": "Lista căutărilor recente",
  "No data": "Nu există date",
  "spare part": "piesă de schimb",
  "none": "niciunul",
  "no value": "nicio valoare",
  "No results found": "Nu s-au găsit rezultate",
  "Spare parts for": "Piese de schimb pentru",
  "Could not load cumulated data": "Nu s-a putut încărca datele cumulate",
  "commissioning part": "partea de punere în funcțiune",
  "wear part": "piesă de uzură",
  "Search": "Căutare",
  "Tk": "Tk",
  "Spare part number": "Numărul piesei de schimb",
  "drawing": "desen",
  "Products for": "Produse pentru",
  "Available": "Disponibil",
  "MM": "MM",
  "The entered order code is invalid": "Codul de comandă introdus nu este valabil",
  "Recommended": "Recomandate",
  "No data available for the entered search parameters": "Nu există date disponibile pentru parametrii de căutare introduși",
  "Search spare parts": "Căutare piese de schimb",
  "Order code / product root / serial number": "Codul de comandă / rădăcina produsului / numărul de serie",
  "Characteristic": "Caracteristică",
  "Please enter an order code": "Vă rugăm să introduceți un cod de comandă",
  "Regarding quality- and security-aspects Endress+Hauser strongly recommends the exclusive use of genuine Endress+Hauser spare parts. The instrument may only be maintained and repaired by qualified personnel. The device documentation, applicable standards and legal requirements as well as any certificates have to be observed!": "În ceea ce privește aspectele legate de calitate și securitate, Endress+Hauser recomandă insistent utilizarea exclusivă a pieselor de schimb Endress+Hauser originale. \nInstrumentul poate fi întreținut și reparat numai de către personal calificat. \nDocumentația dispozitivului trebuie să respecte standardele aplicabile și cerințele legale, precum și orice certificate!",
  "Maintenance advice": "Sfaturi de întreținere",
  "Mo.": "Mo.",
  "For which product(s) can my spare part be used? Filling in the spare part order code (e.g. 71002865 or XPD0024) shows the relevant devices this spare part can be used in.": "Pentru ce produs(e) poate fi utilizată piesa mea de schimb? Completarea codului de comandă al piesei de schimb (de exemplu, 71002865 sau XPD0024) arată dispozitivele relevante în care poate fi utilizată această piesă de schimb.",
  "tool": "instrument",
  "Production numbers": "Cifre de producție",
  "New alternative": "Alternativă nouă",
  "There are no items selected. Please use the checkboxes to make your selection": "Nu există elemente selectate. Vă rugăm să utilizați casetele de selectare pentru a face selecția dvs.",
  "Service segmentation": "Segmentarea serviciilor",
  "Seg": "Seg",
  "Valid": "Valabil",
  "Pos": "Pos",
  "Value": "Valoare",
  "service segmentation 2": "Părți care necesită cunoștințe de bază. Participarea cu succes la formarea de bază E+H este o condiție prealabilă.",
  "Phase out date": "Data eliminării treptate",
  "service segmentation 1": "Părți care necesită cunoștințe de bază.",
  "Which spare parts are available for my product? Filling in the order code (e.g. FTC260-AA2A1 or PMC51-BA21JB1CGBTDJB) or the product id (e.g. FTC260 or 83F50) shows the relevant spare parts.": "Ce piese de schimb sunt disponibile pentru produsul meu? Completarea codului de comandă (de exemplu, FTC260-AA2A1 sau PMC51-BA21JB1CGBTDJB) sau a identificatorului produsului (de exemplu, FTC260 sau 83F50) arată piesele de schimb relevante.",
  "Set filter": "Setați filtrul",
  "Search date": "Data căutării",
  "Group": "Grup",
  "Warning": "Avertisment",
  "Description": "Descriere",
  "Cancel": "Anulează",
  "service segmentation 4": "Piese pentru reparații în fabrică. Cunoștințele de specialitate sunt obligatorii.",
  "service segmentation 3": "Părți care necesită cunoștințe specializate. Participarea cu succes la formarea avansată E+H este o condiție prealabilă.",
  "Drawing Position Number": "Numărul poziției desenului",
  "Spare parts search": "Căutare piese de schimb",
  "Confirm": "Confirmați",
  "Ordercode too short": "Cod de comandă prea scurt",
  "Product status": "Starea produsului",
  "Open": "Deschis",
  "Clear": "Clar",
  "PDF file with assembly instructions": "Fișier PDF cu instrucțiuni de asamblare",
  "Search products": "Căutare produse",
  "Export": "Export",
  "Production date": "Data producției",
  "Order stop": "Oprire comandă",
  "Calibration until": "Calibrare până la",
  "PDF file with compatibility information": "Fișier PDF cu informații despre compatibilitate",
  "Add selection to cart": "Adăugați selecția în coș",
  "Mounting advices": "Sfaturi de montaj",
  "Recommended parts only": "Numai piese recomandate",
  "not applicable": "nu se aplică",
  "accessories": "accesorii",
  "Cumulative spare parts list": "Lista cumulativă a pieselor de schimb",
  "YYYY": "YYYY",
  "Title": "Titlu",
  "Error": "Eroare",
  "Ordercode too long": "Cod de comandă prea lung",
  "Functions": "Funcții",
  "Rec": "Rec",
  "Type": "Tip",
  "Spare sensor until": "Senzor de rezervă până la",
  "Spare parts until": "Piese de schimb până la",
  "Filter": "Filtru",
  "Check all": "Verificați toate",
  "Order code": "Cod de comandă",
  "Repair until": "Reparare până la",
  "Tag": "Etichetă",
  "Ok": "Bine",
  "Category code": "Cod de categorie",
  "Phase out": "Eliminare treptată",
  'Compatibility advices': 'Documente suplimentare',
  'Co.': 'Doc. supl.',
} as LocalizedDictionary;
